<div>
    <div class="live-updates-header-container">
        <!-- <div class="live-updates-header">{{ 'bikeshop.workshop.jobcard.manage.live_updates' | translate }}</div> -->

        <div class="live-updates-actions" *ngIf="!showNotesInline">

            <!-- <hub-button [icon]="'calendar-pen-lines'" [size]="'xl'"
                pTooltip="{{ 'bikeshop.workshop.jobcard.booking_details' | translate }}"
                tooltipPosition="bottom" [style]="'outline'" (buttonClick)="openBookingDetails()" /> -->

          <div>
            <hub-button [icon]="'square-poll-horizontal'"  *ngIf="showAuditTrail"
                        [style]="'outline'" [size]="'lg'" class="lock-exempt"
                        pTooltip="{{ 'audit_trail' | translate }}"
                        tooltipPosition="top" (buttonClick)="openAuditHistory()"></hub-button>

            <div class="custom-questions-button-container lock-exempt" *ngIf="jobcard.customQuestions?.length > 0"
                 (mouseenter)="!isTouchDevice && showCustomQuestionsPreview()"
                 (mouseleave)="!isTouchDevice && hideCustomQuestionsPreview()"
                 (touchstart)="onTouchStart($event, 'custom-questions')" (touchend)="onTouchEnd($event)"
                 (touchmove)="onTouchMove($event)">
              <hub-button [icon]="'user-question'" [style]="'outline'" [size]="'lg'"
                          (buttonClick)="onCustomQuestionsButtonClick($event)"></hub-button>
              <app-workshop-jobcard-custom-questions-preview *ngIf="customQuestionsPreview.show && hasCustomQuestionsData()"
                                                             [customQuestions]="jobcard.customQuestions"  class="custom-questions-preview-popup">
              </app-workshop-jobcard-custom-questions-preview>
            </div>
            <hub-button [icon]="hasMandatoryChecklistItems ? 'clipboard-list' : 'clipboard-list'"  class="lock-exempt"
                        *ngIf="hasChecklistItems" [style]="hasMandatoryChecklistItems ? 'alert' : 'outline'" [size]="'lg'"
                        pTooltip="{{ (hasMandatoryChecklistItems ? 'bikeshop.modal.update_job_card.checklist.complete_mandatory_checklist' : 'bikeshop.modal.update_job_card.checklist.checklist_items') | translate }}"
                        tooltipPosition="top" (buttonClick)="openChecklists()"></hub-button>
            <hub-button *ngIf="isWaiversEnabled" [icon]="'signature'" [style]="'outline'" [size]="'lg'" class="lock-exempt"
                        pTooltip="{{ 'bikeshop.modal.update_job_card.tab.waivers' | translate }}" tooltipPosition="top"
                        (buttonClick)="openWaivers()"></hub-button>


            <!-- <div class="notes-button-container" (mouseenter)="!isTouchDevice && showNotesPreview('INTERNAL')"
      (mouseleave)="!isTouchDevice && hideNotesPreview()"
      (touchstart)="onTouchStart($event, 'notes-internal')" (touchend)="onTouchEnd($event)"
      (touchmove)="onTouchMove($event)">
      <hub-button [icon]="'internal-notes'" [size]="'xl'"
          [badgeValue]="internalNotes?.notes?.length || ''" tooltipPosition="top" [style]="'outline'"
          (buttonClick)="onNotesButtonClick('INTERNAL', $event)" />
      <app-workshop-jobcard-notes-preview *ngIf="notesPreview.show && notesPreview.type === 'INTERNAL'"
          [noteType]="'INTERNAL'" [notes]="internalNotes?.notes || []" class="notes-preview-popup">
      </app-workshop-jobcard-notes-preview>
  </div>
  <div class="notes-button-container" (mouseenter)="!isTouchDevice && showNotesPreview('EXTERNAL')"
      (mouseleave)="!isTouchDevice && hideNotesPreview()"
      (touchstart)="onTouchStart($event, 'notes-external')" (touchend)="onTouchEnd($event)"
      (touchmove)="onTouchMove($event)">
      <hub-button [icon]="'external-notes'" [size]="'xl'"
          [badgeValue]="externalNotes?.notes?.length || ''" tooltipPosition="top" [style]="'outline'"
          (buttonClick)="onNotesButtonClick('EXTERNAL', $event)" />
      <app-workshop-jobcard-notes-preview *ngIf="notesPreview.show && notesPreview.type === 'EXTERNAL'"
          [noteType]="'EXTERNAL'" [notes]="externalNotes?.notes || []" class="notes-preview-popup">
      </app-workshop-jobcard-notes-preview>
  </div>
  <div class="notes-button-container" (mouseenter)="!isTouchDevice && showNotesPreview('CLIENTNOTES')"
      (mouseleave)="!isTouchDevice && hideNotesPreview()"
      (touchstart)="onTouchStart($event, 'notes-client')" (touchend)="onTouchEnd($event)"
      (touchmove)="onTouchMove($event)">
      <hub-button [icon]="'customer-notes'" [size]="'xl'" [badgeValue]="clientNotes?.notes?.length || ''"
          tooltipPosition="top" [style]="'outline'"
          (buttonClick)="onNotesButtonClick('CLIENTNOTES', $event)" />
      <app-workshop-jobcard-notes-preview *ngIf="notesPreview.show && notesPreview.type === 'CLIENTNOTES'"
          [noteType]="'CLIENTNOTES'" [notes]="clientNotes?.notes || []" class="notes-preview-popup">
      </app-workshop-jobcard-notes-preview>
  </div> -->


            <div class="messaging-button-container lock-exempt" (mouseenter)="!isTouchDevice && showMessagingPreview()"
                 (mouseleave)="!isTouchDevice && hideMessagingPreview()"
                 (touchstart)="onTouchStart($event, 'messaging')" (touchend)="onTouchEnd($event)"
                 (touchmove)="onTouchMove($event)">
              <hub-button [icon]="'message-circle-chat'" [size]="'xl'" [badgeValue]="unreadMessages"
                          [badgeColor]="'#FB7A01'"
                          pTooltip="{{ !hasMessagesData() ? ('bikeshop.workshop.jobcard.manage.messages' | translate) : '' }}"
                          tooltipPosition="top" [style]="'outline'" (buttonClick)="onMessagingButtonClick($event)" />
              <app-workshop-jobcard-messaging-preview *ngIf="messagingPreview.show && hasMessagesData()"
                                                      [messages]="messages" [jobcard]="jobcard" [unreadCount]="unreadMessages"
                                                      class="messaging-preview-popup">
              </app-workshop-jobcard-messaging-preview>
            </div>

            <div class="collections-button-container lock-exempt"
                 *ngIf="partnerData.OffersCollections || partnerData.OffersDropOffs"
                 (mouseenter)="!isTouchDevice && showCollectionsPreview()"
                 (mouseleave)="!isTouchDevice && hideCollectionsPreview()"
                 (touchstart)="onTouchStart($event, 'collections')" (touchend)="onTouchEnd($event)"
                 (touchmove)="onTouchMove($event)">
              <hub-button [icon]="'truck'" [size]="'xl'"
                          [badgeValue]="jobcard.collectionsDeliveries.allowCollection && jobcard.collectionsDeliveries.allowDelivery ? 2 : (jobcard.collectionsDeliveries.allowCollection || jobcard.collectionsDeliveries.allowDelivery) ? 1 : null"
                          [badgeColor]="'#76C653'"
                          pTooltip="{{ !hasCollectionDeliveryData() ? ('bikeshop.workshop.jobcard.collections_deliveries' | translate) : '' }}"
                          tooltipPosition="top" [style]="'outline'" (buttonClick)="onCollectionsButtonClick($event)" />
              <app-workshop-jobcard-collections-deliveries-preview *ngIf="collectionsPreview.show && hasCollectionDeliveryData()"
                                                                   [collectionsDeliveries]="jobcard.collectionsDeliveries" class="collections-preview-popup">
              </app-workshop-jobcard-collections-deliveries-preview>
            </div>

            <hub-button [icon]="'transfer-job'" [size]="'xl'"
                        pTooltip="{{ 'bikeshop.workshop.jobcard.manage.move_job' | translate }}" tooltipPosition="top"
                        [disabled]="!(canMoveJobCard &&  jobcard.statusID < 40)" [style]="'outline'"
                        (buttonClick)="moveJobCard()" />
            <hub-button [icon]="'printer'" class=" lock-exempt"
                        pTooltip="{{ 'bikeshop.modal.update_job_card.job_card.print_this_job_card' | translate }}"
                        tooltipPosition="top" [size]="'xl'" [style]="'outline'" (buttonClick)="printJobCard()" />
          </div>
            <div>
                <!-- <hub-button *ngIf="jobcard.statusID >= 40"
                    text="{{ 'bikeshop.modal.update_job_card.job_card.reopen_job_card' | translate }}"
                    [disabled]="reopening" [loading]="reopening" [size]="'xl'" [style]="'outline'"
                    (buttonClick)="reopenJobCard()" />
                <hub-button *ngIf="jobcard.statusID >= 40 && jobcard.statusID <= 45 && !jobcard.isFitting"
                    text="{{ 'bikeshop.workshop.jobcard.manage.mark_as_collected' | translate }}"
                    [disabled]="markingCollected" [loading]="markingCollected" [size]="'xl'" [style]="'secondary'"
                    (buttonClick)="markAsCollected()" />
                <hub-button *ngIf="!jobcard.isFitting && !(jobcard.statusID >= 25 && jobcard.statusID != 35)"
                    pTooltip="{{ (jobcard.itemIsHere ? 'bikeshop.general.mark_as_not_here' : 'bikeshop.general.mark_as_here') | translate }}"
                    tooltipPosition="top"
                    [text]="canDeviceHover ? '' : (jobcard.itemIsHere ? 'bikeshop.general.mark_as_not_here' : 'bikeshop.general.mark_as_here') | translate"
                    [style]="jobcard.itemIsHere ? 'outline' : 'secondary'" [size]="'xl'"
                    [icon]="jobcard.itemIsHere ? 'item-here' : 'item-not-here'" (buttonClick)="toggleItemIsHere()">
                </hub-button> -->
                <!-- <div id="statusDropdown" class="custom-dropdown {{getStatusStyle()}}"
                    *ngIf="jobActions && jobActions.length > 0 && jobcard.statusID < 40"
                    [ngClass]="{ open: showStatusActions }" (click)="toggleStatusDropdown($event)">
                    <div class="selected-option">
                        <span>{{ getCurrentStatusLabel() }}</span>
                        <span class="dropdown-icon" (click)="toggleStatusDropdown($event)">
                            <daz-icon *ngIf="!showStatusActions" [size]="'24px'" [color]="'#6D6D6D'"
                                [name]="'chevron-down'"></daz-icon>
                            <daz-icon *ngIf="showStatusActions" [size]="'24px'" [color]="'#6D6D6D'"
                                [name]="'chevron-up'"></daz-icon>
                        </span>
                    </div>
                    <ul class="dropdown-menu-options" *ngIf="showStatusActions">
                        <li *ngFor="let action of jobActions"
                            (click)="selectStatusOption(action); $event.stopPropagation()"
                            [ngStyle]="{'display' : (action.id === 20 && jobcard.statusID === 15 && action.key === 15) || (action.id === 20 && jobcard.statusID > 15 && action.key === 20) || ((action.id !== 20 && action.id !== 40) || (action.id === 40))  ? 'flex' : 'none'}"
                            [class.selected]="action.id === jobcard.statusID"
                            [class.disabled]="action.id === 40 && hasMandatoryChecklistItems">
                            <span class="status-color {{getStatusIndicatorStyle(action.id)}}"></span>
                            <span>{{ action.label }}</span>
                            <daz-icon *ngIf="action.id === jobcard.statusID" [name]="'check'" [size]="'20px'"
                                [color]="'#EE3158'"></daz-icon>
                        </li>
                    </ul>
                </div>
                <hub-button [icon]="sendComms ?'send-alt-2' : 'cross'"
                    pTooltip="{{ (sendComms ? 'bikeshop.workshop.jobcard.manage.disable_notify_customer_header' : 'bikeshop.workshop.jobcard.manage.notify_customer_header') | translate }}"
                    tooltipPosition="top" [size]="'xl'" [style]="sendComms ? 'outline' : 'alert'"
                    (buttonClick)="sendComms = !sendComms" /> -->
            </div>

        </div>
    </div>

    <div *ngIf="hasMandatoryChecklistItems" class="mandatory-checklist-warning">
        {{'bikeshop.checklist.complete_mandatory_checklist_items' | translate}}
    </div>



    <!-- <div class="notes-messages-container">
        <div class="notes-container">
            <div class="header">
                <div>{{'bikeshop.modal.update_job_card.collections.customer_notes' | translate}}</div>
                <div>
                    <hub-button [icon]="'arrow-up-right'" [style]="'borderless'" [size]="'lg'"
                        (buttonClick)="openNotes('INTERNAL')"></hub-button>
                </div>
            </div>
            <div class="notes-messages-content">
                <div *ngIf="!jobcard.latestNote?.note">{{ 'bikeshop.workshop.jobcard.manage.no_notes' | translate }}
                </div>
                <div *ngIf="jobcard.latestNote?.createdDate">{{jobcard.latestNote?.createdDate+'Z' | date:
                    countryData.AngularDateFormat + ' h:mm a'}}</div>
                <div *ngIf="jobcard.latestNote?.note">{{jobcard.latestNote?.note}}</div>
            </div>
        </div>

        <div class="messages-container">
            <div class="header">
                <div>{{'bikeshop.workshop.jobcard.manage.messages' | translate}}</div>
                <div>
                    <hub-button [icon]="'arrow-up-right'" [style]="'borderless'" [size]="'lg'"
                        (buttonClick)="openMessages()"></hub-button>
                </div>
            </div>
            <div class="notes-messages-content">
                <div *ngIf="!jobcard.latestIncomingMessage?.message">{{ 'bikeshop.workshop.jobcard.manage.no_messages' |
                    translate }}</div>
                <div *ngIf="jobcard.latestIncomingMessage?.message">
                    <div class="message-header">{{jobcard.customer?.Name}} {{jobcard.customer?.Surname}} <span
                            class="date">{{ jobcard.latestIncomingMessage.createdDate | date :
                            countryData.AngularDateFormat + ' h:mm a'}}</span></div>
                    <div class="message-content">{{ jobcard.latestIncomingMessage.message }}</div>
                </div>
            </div>
        </div>

    </div> -->
    <!-- <div class="mini-dashboard-container"
        *ngIf="!showNotesInline && (isWaiversEnabled || hasChecklistItems || jobcard.customQuestions?.length > 0)">
        <div class="custom-questions-button-container" *ngIf="jobcard.customQuestions?.length > 0"
            (mouseenter)="!isTouchDevice && showCustomQuestionsPreview()"
            (mouseleave)="!isTouchDevice && hideCustomQuestionsPreview()"
            (touchstart)="onTouchStart($event, 'custom-questions')" (touchend)="onTouchEnd($event)"
            (touchmove)="onTouchMove($event)">
            <hub-button [icon]="'user-question'" [iconPosition]="'right'" [style]="'outline'" [size]="'lg'"
                [text]="'bikeshop.modal.update_job_card.tab.custom_questions' | translate"
                (buttonClick)="onCustomQuestionsButtonClick($event)"></hub-button>
            <app-workshop-jobcard-custom-questions-preview
                *ngIf="customQuestionsPreview.show && hasCustomQuestionsData()"
                [customQuestions]="jobcard.customQuestions" class="custom-questions-preview-popup">
            </app-workshop-jobcard-custom-questions-preview>
        </div>
        <hub-button [icon]="hasMandatoryChecklistItems ? '' : 'clipboard-list'" [iconPosition]="'right'"
            *ngIf="hasChecklistItems" [style]="hasMandatoryChecklistItems ? 'alert' : 'outline'" [size]="'lg'"
            [text]="(hasMandatoryChecklistItems ? 'bikeshop.modal.update_job_card.checklist.complete_mandatory_checklist' : 'bikeshop.modal.update_job_card.checklist.checklist_items') | translate"
            (buttonClick)="openChecklists()"></hub-button>
        <hub-button *ngIf="isWaiversEnabled" [icon]="'signature'" [iconPosition]="'right'" [style]="'outline'"
            [size]="'lg'" [text]="'bikeshop.modal.update_job_card.tab.waivers' | translate"
            (buttonClick)="openWaivers()"></hub-button>
    </div> -->


    <p-toast position="bottom-center" styleClass="hubtiger-jobcard-toast"></p-toast>
    <p-confirmDialog key="jobcard"></p-confirmDialog>
